<template>
    <v-card v-if="user">
        <v-card-title>
            Mitarbeiter
            <v-spacer/>
            <v-btn v-if="!readonly" icon color="primary" @click="resetEvent">
                <v-icon>mdi-close</v-icon>
            </v-btn>
        </v-card-title>
        <v-card-text>
            <v-row no-gutters>
                <v-col cols="12" md="6">
                    <div>Nachname, Vorname</div>
                    <div class="body-1 black--text">{{user.last_name}}, {{user.first_name}}</div>
                </v-col>
            </v-row>
        </v-card-text>
        <v-card-text>
            <div>Personalnummer</div>
            <div class="body-1 black--text">{{user.staff_number}}</div>
        </v-card-text>
        <v-card-text v-if="user.orga_unit">
            <div>Organisationseinheit</div>
            <div class="body-1 black--text">{{user.orga_unit.name}}</div>
        </v-card-text>
        <v-card-text v-if="user.supervisors_names">
            <div>Führungskraft</div>
            <div class="body-1 black--text">{{user.supervisors_names}}</div>
        </v-card-text>
    </v-card>
</template>

<script>
    import {mapActions} from 'vuex';

    export default {
        props: ['payload', 'readonly'],
        name: "app-utility-user-card",
        data: () => ({
            user: {
                first_name: '',
                last_name: '',
                staff_number: '',
                supervisors_names: '',
                orga_unit: {
                    name: ''
                },
            },
        }),
        methods: {
            ...mapActions({}),
            resetEvent() {
                this.$emit('reset');
            }

        },
        mounted() {
            if (this.payload.id){
                this.user = this.payload;
            }
        },
        watch: {
            payload: function(val){
                if (val.id){
                    this.user = val;
                }
            },
        },
    }
</script>

<style scoped>

</style>